import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'boxicons/css/boxicons.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import UpdateNotification from './Components/UpdateNotification/UpdateNotification';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// Function to show update notification
const showUpdateNotification = (registration) => {
  // Create a container for the notification
  const notificationContainer = document.createElement('div');
  notificationContainer.id = 'update-notification-container';
  document.body.appendChild(notificationContainer);

  const notificationRoot = ReactDOM.createRoot(notificationContainer);

  const handleUpdate = () => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  };

  const handleDismiss = () => {
    notificationRoot.unmount();
    document.body.removeChild(notificationContainer);
  };

  notificationRoot.render(
    <UpdateNotification onUpdate={handleUpdate} onDismiss={handleDismiss} />
  );
};

// Register service worker for offline support and auto-updates
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    console.log('New version available! Showing update notification...');
    showUpdateNotification(registration);
  },
  onSuccess: (registration) => {
    console.log('ServiceWorker registration successful');

    // Check for updates every 60 seconds
    setInterval(() => {
      registration.update();
    }, 60000);
  },
});

// Listen for controller change (new service worker activated)
let refreshing = false;
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  if (!refreshing) {
    refreshing = true;
    window.location.reload();
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
